export const page6 = {
  "name": "page6",
  "title": "Body shape and weight",
  "elements": [
    {
      "type": "rating",
      "name": "body_weight_rating",
      "title": "What do you think about your current body weight? I want to...",
      "autoGenerate": false,
      "isRequired": true,
      "rateCount": 3,
      "rateValues": [
        {
          "value": 1,
          "text": "Gain weight"
        },
        {
          "value": 2,
          "text": "Maintain my weight"
        },
        {
          "value": 3,
          "text": "Lose weight"
        }
      ],
      "rateMax": 3
    },
    {
      "type": "rating",
      "name": "weight_change_attempts",
      "title": "Have you made attempts to change your weight?",
      "autoGenerate": false,
      "isRequired": true,
      "rateCount": 3,
      "rateValues": [
        {
          "value": 1,
          "text": "No"
        },
        {
          "value": 2,
          "text": "Yes, in the past"
        },
        {
          "value": 3,
          "text": "Yes, recently"
        }
      ]
    },
    {
      "type": "rating",
      "name": "weight_change_attempts_success",
      "title": "Were those attempts successfull?",
      "visibleIf": "{weight_change_attempts} > 1",
      "autoGenerate": false,
      "isRequired": true,
      "rateCount": 3,
      "rateValues": [
        {
          "value": 1,
          "text": "Yes"
        },
        {
          "value": 2,
          "text": "No"
        },
        {
          "value": 3,
          "text": "N/A"
        }
      ]
    }
  ]
};